/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-02-10 15:32:33
 * @LastEditTime: 2025-04-07 15:17:11
 */
import React, { useState, useEffect, useRef } from "react";
import { Modal, Form, Input, Button, Select, message } from 'antd';
import { useAppSelector } from '@/redux/hooks';
import { pmsProductObject } from '../../type';
import selectImg from '../../img/select.png';
import { priceEnquiry } from '@/api/detail';
import './index.scss';
interface IProps {
  priceModal: boolean,
  typeInfo: pmsProductObject[],
  changeModal: any,
  imgUrl: string,
  title: string,
  productSn: string|null,
  typeIndex: number
}
const PriceDialog: React.FC<IProps> = (props) => {
  const { priceModal, changeModal, typeInfo, imgUrl, title, productSn, typeIndex } = props;
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectValue, setSelectValue] = useState<number|null>(null); // 规格型号选择
  const [selectOptions, setSelectOptions] = useState([]); // 规格型号
  const userInfo = useAppSelector((state) => state.user.userInfo);

  useEffect(() => {
    setIsModalOpen(priceModal);
    const getType: any = [];
    if (typeInfo.length > 0 && priceModal) {
      typeInfo.forEach((tRes) => {
        getType.push({
          value: tRes.id,
          label: tRes.models
        })
      })
      setSelectOptions(getType);
      setSelectValue(typeInfo[typeIndex].id)
    }

  }, [typeInfo,priceModal])
  useEffect(() => {
    // 当初始化用户信息后，设置表单的值
    if (userInfo.tel) {
      form.setFieldsValue({ tel: userInfo.tel });
    }
  }, [userInfo, form, priceModal]);
  const handleCancel = () => {
    changeModal(false);
    form.resetFields();
  };
  const finishSubmit = (value: any) => {
    const params = value;
    params.productSn = productSn;
    if(selectValue !== null) {
      params.modelId = selectValue;
    }
    try{
      priceEnquiry((params)).then((pRes: any) => {
        if (pRes.success) {
          message.success('提交成功');
          handleCancel();
        } else {
          message.warning(pRes.message);
        }
      })
    }catch (error) {
      console.log('error:',error)
    }
    
  }
  const optionsChange = (value: number) => {
    setSelectValue(value);
  };
  return (
    <Modal
      title="获取价格"
      open={isModalOpen}
      onCancel={handleCancel}
      className="price-dialog-main"
      footer={false}
      width={600}
    >
      <div className="product-info-top">
        <h1 title={title}>{title}</h1>
        <div className="modal-content">
          <img className="product-show" src={imgUrl} alt='' />
          <div className="product-type">
            <h2>规格型号</h2>
            {
              typeInfo.length > 0 &&
              <Select
                style={{ width: '100%' }}
                placeholder={typeInfo[typeIndex].models}
                onChange={optionsChange}
                options={selectOptions}
                getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
              />
            }
          </div>
        </div>
       
      </div>

      <Form form={form} layout="vertical" onFinish={(values) => finishSubmit(values)} >
        <h2>个人信息</h2>
        <Form.Item
          label="联系人"
          name="name"
          className="personal-name"
          rules={[
            { required: true, message: '' },
            { validator: (_, value) => value?.trim() ? Promise.resolve() : Promise.reject(new Error('请先输入联系人')) }
          ]}
        >
          <Input type='string' maxLength={24} />
        </Form.Item>
        <div className="subsidiary-content">
          <Form.Item
            label="所在单位"
            name="subsidiary"
            className="vertical-label"
            rules={[
              { required: true, message: '' },
              { validator: (_, value) => value?.trim() ? Promise.resolve() : Promise.reject(new Error('请先输入所在单位')) }
            ]}
          >
            <Input maxLength={50} />
          </Form.Item>
          <Form.Item
            label="职位"
            name="post"
            className="label-right"
            rules={[
              { required: true, message: '' },
              { validator: (_, value) => value?.trim() ? Promise.resolve() : Promise.reject(new Error('请先输入职位')) }
            ]}
          >
            <Input maxLength={50} />
          </Form.Item>
        </div>
        
        <h2 className="contact-way">联系方式</h2>
        <div className="subsidiary-content">
          <Form.Item
            label="手机号"
            name="tel"
            className="vertical-label"
            rules={[
              { required: true, message: '请先输入手机号' },
              {
                type: 'string',
                pattern: /^1[3-9]\d{9}$/,
                message: '手机号格式错误',
              },
            ]}
          >
            <Input maxLength={11} value={form.getFieldValue('tel')} />
          </Form.Item>
          <Form.Item
            label="微信"
            name="wechat"
            className="label-right"

          >
            <Input maxLength={50} />
          </Form.Item>
        </div>
       
        <p>*提交后我司工作人员会尽快与您联系</p>
        <Form.Item>
          <div className="dialog-bottom">
            <Button className="submit-info" type="primary" htmlType="submit">提交</Button>
            <Button onClick={handleCancel}>取消</Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default PriceDialog;